module.exports = __webpack_public_path__ + "img/hotel-marques-de-pombal.41aa656c.jpg";